import React, { Component } from "react";

class LuLaErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("LuLaErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
          <h2>Något gick fel</h2>
          <p>Sidan kunde inte laddas. Försök ladda om sidan.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', fontSize: '16px' }}
          >
            Ladda om
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default LuLaErrorBoundary;
